import { __rest, __assign } from 'tslib';
import React, { useState, useRef, useMemo } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import throttle from 'lodash/throttle';
import { SelectMobile, SelectModalMobile } from '../../../select/esm/mobile';
import { Footer } from '../../../select/esm/shared';
import { AutocompleteMobileField } from '../autocomplete-mobile-field/Component.js';
import { OnInputReason } from '../enums.js';
import { searchFilterStub } from '../utils.js';
import '../../../form-control/esm/mobile';
import '../../../input/esm/shared';
import '../../../shared/esm';
import '../../../status-badge/esm';
import '@alfalab/hooks';

var styles = {"input":"input-autocomplete__input_1awlg"};
require('./mobile.css');

var InputAutocompleteMobile = React.forwardRef(function (_a, ref) {
    var _b;
    var _c;
    var Input = _a.Input, value = _a.value, name = _a.name, _d = _a.Arrow, Arrow = _d === void 0 ? null : _d, label = _a.label, _e = _a.placeholder, placeholder = _e === void 0 ? '' : _e, _f = _a.size, size = _f === void 0 ? 48 : _f, openProp = _a.open, onInput = _a.onInput, onOpen = _a.onOpen, multiple = _a.multiple, inputProps = _a.inputProps, _g = _a.isBottomSheet, isBottomSheet = _g === void 0 ? true : _g, dataTestId = _a.dataTestId, transitionProps = _a.transitionProps, onCancel = _a.onCancel, onApply = _a.onApply, title = _a.title, success = _a.success, restProps = __rest(_a, ["Input", "value", "name", "Arrow", "label", "placeholder", "size", "open", "onInput", "onOpen", "multiple", "inputProps", "isBottomSheet", "dataTestId", "transitionProps", "onCancel", "onApply", "title", "success"]);
    var _h = useState(false), open = _h[0], setOpen = _h[1];
    var frozenValue = useRef('');
    var searchInputRef = useRef(null);
    var targetRef = useRef(null);
    var restorePrevValue = function () { return onInput === null || onInput === void 0 ? void 0 : onInput(frozenValue.current, OnInputReason.Close); };
    var setModalVisibility = function (isOpen) {
        if (isOpen) {
            frozenValue.current = value || '';
        }
        if (openProp === undefined) {
            setOpen(isOpen);
        }
        onOpen === null || onOpen === void 0 ? void 0 : onOpen({ open: isOpen, name: name });
    };
    var handleOpen = function (payload) {
        setModalVisibility(Boolean(payload.open));
    };
    var handleOptionsListTouchMove = useMemo(function () {
        return throttle(function () {
            var input = searchInputRef.current;
            if (input && document.activeElement === input) {
                input.blur();
            }
        }, 300);
    }, []);
    var handleApply = function () {
        setModalVisibility(false);
        onApply === null || onApply === void 0 ? void 0 : onApply();
    };
    var handleCancel = function () {
        setModalVisibility(false);
        restorePrevValue();
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    };
    var handleExiting = function (node) {
        var _a, _b;
        (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        (_b = transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.onExiting) === null || _b === void 0 ? void 0 : _b.call(transitionProps, node);
    };
    var isOpen = Boolean(open || openProp);
    var Component = isBottomSheet ? SelectMobile : SelectModalMobile;
    var componentProps = (_b = {
            title: title || label || placeholder,
            onClose: restorePrevValue,
            transitionProps: __assign(__assign({}, transitionProps), { onExiting: handleExiting })
        },
        _b[isBottomSheet ? 'containerProps' : 'componentDivProps'] = {
            onTouchMove: handleOptionsListTouchMove,
        },
        _b);
    var clear = (_c = inputProps === null || inputProps === void 0 ? void 0 : inputProps.clear) !== null && _c !== void 0 ? _c : false;
    return (React.createElement(Component, __assign({ Field: AutocompleteMobileField }, restProps, (isBottomSheet
        ? { bottomSheetProps: componentProps }
        : {
            modalProps: componentProps,
            modalHeaderProps: { title: title },
        }), { dataTestId: dataTestId, useWithApplyHook: false, showSearch: true, searchProps: {
            value: value,
            filterFn: searchFilterStub,
            componentProps: __assign(__assign({ leftAddons: null, placeholder: placeholder }, inputProps), { className: cn(styles.input, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className), clear: clear, ref: mergeRefs([searchInputRef, inputProps === null || inputProps === void 0 ? void 0 : inputProps.ref]), onChange: function (_, payload) { return onInput === null || onInput === void 0 ? void 0 : onInput(payload.value, OnInputReason.Change); } }),
        }, Search: Input, ref: mergeRefs([targetRef, ref]), open: isOpen, onOpen: handleOpen, Arrow: Arrow, placeholder: placeholder, label: label, size: size, name: name, multiple: multiple, optionsListProps: __assign({ footer: (React.createElement(Footer, { showClear: true, handleClear: handleCancel, handleApply: handleApply, clearText: '\u041E\u0442\u043C\u0435\u043D\u0430', applyText: '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C', dataTestId: dataTestId })) }, restProps.optionsListProps), fieldProps: __assign({ value: isOpen ? frozenValue.current : value, clear: clear, onClear: clear ? inputProps === null || inputProps === void 0 ? void 0 : inputProps.onClear : undefined, success: success }, restProps.fieldProps) })));
});

export { InputAutocompleteMobile };
